import React, { Fragment } from 'react';
import Styled from './styles';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import api from '../../../lib/api';
import {
  getCountryFromSymbol,
  getFilteredCountries
} from '../../../utils/countries';
import { Search } from '@material-ui/icons';
import { Divider, InputAdornment } from 'material-ui';
import { ListSubheader } from 'material-ui';
import { PhoneNumberUtil } from 'google-libphonenumber';
import moment from 'moment';
import { validatePhoneNumber } from '../../../utils/validate-phone';
import { Typography } from 'material-ui';
import { Dialog } from '@material-ui/core';
import { DOUBLETICK_ENTERPRISE_PLANS } from '../../../utils/constans';
const phoneUtil = PhoneNumberUtil.getInstance();

const styles = theme => ({
  textField: {
    marginRight: theme.spacing.unit,
    width: 276,
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    padding: '10px'
  },
  input: {
    fontSize: 16,
    fontWeight: 'normal',
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  button: {
    backgroundColor: '#42FFBB',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: '#42FFBB'
    }
  },
  selectDropDown: {
    marginRight: theme.spacing.unit,
    width: 180,
    border: '1px solid #C4C4C4',
    padding: '10px',
    borderRadius: 8,
    textTransform: 'capitalize',
    marginBottom: 14
  },
  selectMenu: {
    whiteSpace: 'normal',
    textOverFlow: ''
  },
  phoneSelect: {
    border: '1px solid #C4C4C4',
    padding: '17px 24px',
    borderRadius: 8,
    paddingLeft: 12
  },
  subheader: {
    backgroundColor: '#fff'
  }
});

class RazorpaySmartCollect extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.initialState = {
      phone: '',
      amount: '',
      startDate: '',
      duration: '',
      email: '',
      gst: '',
      name: '',
      companyName: '',
      state: 'Select State',
      countryCode: '+91',
      country: 'Select Country',
      numberOfUsers: '',
      numberOfUsersError: false,
      nameError: false,
      companyNameError: false,
      phoneError: false,
      amountError: false,
      durationError: false,
      planError: false,
      emailError: false,
      startDateError: false,
      errorRazorpaySmartCollect: false,
      showSnackBar: false,
      message: '',
      loading: false,
      countriesSearchTerm: '',
      statesSearchTerm: '',
      states: [],
      loadingStates: false,
      loadingDuration: false,
      plan: ''
    };
    this.state = {
      durationMonths: [],
      rzpData: undefined,
      showModal: false,
      ...this.initialState
    };
  }

  async componentDidMount() {
    try {
      this.setState({ loadingDuration: true });
      const data = await api.getPlanDuration();
      if (data.month) {
        this.setState({ durationMonths: data.month });
      }
    } catch (err) {
      this.setState({
        showSnackBar: true,
        message:
          err.response.data.message || 'Error occured while fetching durations'
      });
    } finally {
      this.setState({ loadingDuration: false });
    }
  }

  countries = getFilteredCountries();

  onPhoneNumberChange = event => {
    const { value } = event.target;
    this.setState({ phone: value });
  };

  onNameChange = event => {
    const { value } = event.target;
    this.setState({ name: value });
  };

  onNumberOfUsersChange = event => {
    const { value } = event.target;
    this.setState({ numberOfUsers: value });
  };

  onAmountChange = event => {
    const { value } = event.target;
    this.setState({ amount: value });
  };

  onGstnChange = event => {
    const { value } = event.target;
    this.setState({ gst: value });
  };

  onDurationChange = event => {
    const { value } = event.target;
    this.setState({ duration: value });
  };

  onPlanChange = event => {
    const { value } = event.target;
    this.setState({ plan: value });
  };

  onEmailChange = event => {
    this.setState({ email: event.target.value });
  };

  onCompanyNameChange = event => {
    this.setState({ companyName: event.target.value });
  };

  onStateChange = event => {
    this.setState({ state: event.target.value, statesSearchTerm: '' });
  };

  onStartDateChanged = event => {
    this.setState({ startDate: event.target.value });
  };

  getStates = () => {
    if (this.state.states.length > 0) {
      if (!this.state.statesSearchTerm) {
        return this.state.states;
      } else {
        return this.state.states.filter(state =>
          state.name
            .toLowerCase()
            .includes(this.state.statesSearchTerm.toLowerCase())
        );
      }
    }
    return [];
  };

  onDateChange = event => {
    const { value } = event.target;
    this.setState({ startDate: value });
    const minDate = moment()
      .startOf('day')
      .valueOf();
    const selectedDate = moment(value)
      .startOf('day')
      .valueOf();
    if (minDate > selectedDate) {
      this.setState({ startDate: value });
      return;
    }
  };

  cleanState = () => {
    this.setState({
      showSnackBar: false,
      message: '',
      loading: false,
      errorRazorpaySmartCollect: false,
      countriesSearchTerm: '',
      ...this.initialState
    });
  };

  isValidEmail = email => {
    if (email.trim() === '') return true;
    const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return emailRegex.test(email);
  };

  validateForm = () => {
    let errorFlag = false;
    if (!this.state.amount) {
      this.setState({
        amountError: true
      });
      errorFlag = true;
    } else {
      this.setState({
        amountError: false
      });
    }

    if (!this.state.duration) {
      this.setState({
        durationError: true
      });
      errorFlag = true;
    } else {
      this.setState({
        durationError: false
      });
    }

    if (!this.state.plan) {
      this.setState({
        planError: true
      });
      errorFlag = true;
    } else {
      this.setState({
        planError: false
      });
    }

    if (!this.state.name) {
      this.setState({
        nameError: true
      });
      errorFlag = true;
    } else {
      this.setState({
        nameError: false
      });
    }

    if (!this.state.companyName) {
      this.setState({
        companyNameError: true
      });
      errorFlag = true;
    } else {
      this.setState({
        companyNameError: false
      });
    }

    // if (!this.state.startDate) {
    //   this.setState({
    //     startDateError: true
    //   });
    //   errorFlag = true;
    // } else {
    //   this.setState({
    //     startDateError: false
    //   });
    // }

    if (this.state.email) {
      const isValid = this.isValidEmail(this.state.email);
      if (!isValid) {
        this.setState({
          emailError: true
        });
        errorFlag = true;
      } else {
        this.setState({
          emailError: false
        });
      }
    }

    if (!this.state.phone) {
      this.setState({
        phoneError: true
      });
      errorFlag = true;
    } else {
      const isValid = validatePhoneNumber({
        phone: this.state.phone,
        countryCode: getCountryFromSymbol(this.state.countryCode).countryCode,
        phoneUtil: phoneUtil
      });
      if (!isValid) {
        this.setState({ phoneError: true });
        errorFlag = true;
      } else {
        this.setState({
          phoneError: false
        });
      }
    }

    if (!this.state.numberOfUsers) {
      this.setState({
        numberOfUsersError: true
      });
      errorFlag = true;
    } else {
      this.setState({
        numberOfUsersError: false
      });
    }

    return errorFlag;
  };

  onCreateRazorpaySmartId = async () => {
    const error = this.validateForm();

    this.setState({
      errorRazorpaySmartCollect: false,
      loading: true
    });
    if (error) {
      this.setState({
        loading: false
      });
      return;
    }

    const data = {
      loginPhone: `${this.state.countryCode}${this.state.phone}`,
      amount: Number(this.state.amount),
      durationInMonths: Number(this.state.duration),
      productPlan: this.state.plan,
      name: this.state.name.trim() !== '' ? this.state.name.trim() : undefined,
      email: this.state.email.trim() !== '' ? this.state.email : undefined,
      companyName:
        this.state.companyName.trim() !== ''
          ? this.state.companyName
          : undefined,
      gst: this.state.gst.trim() !== '' ? this.state.gst : undefined,
      state: this.state.state.trim() !== '' ? this.state.state : undefined,
      currencyCode: 'INR',
      numberOfUsers: Number(this.state.numberOfUsers),
      countryCode: getCountryFromSymbol(this.state.countryCode).countryCode,
      country: this.state.country.trim() !== '' ? this.state.country : undefined
    };

    try {
      const response = await api.createRazorpaySmartCollectId(data);
      this.setState({
        message: 'Razorpay Smart Collect ID created Successfully',
        showSnackBar: true,
        errorRazorpaySmartCollect: false,
        loading: false,
        rzpData: response,
        showModal: true
      });

      this.cleanState();
    } catch (error) {
      this.setState({
        errorRazorpaySmartCollect: true,
        message: error.response.data.message || 'Something went wrong',
        showSnackBar: true,
        loading: false
      });
    }
  };

  onSnackbarClose = () => {
    this.setState({ showSnackBar: false, message: '' });
  };

  renderSnackbarMessage = () => {
    const { message } = this.state;
    return <Styled.SnackbarMessage>{message}</Styled.SnackbarMessage>;
  };

  isValidAmount = input => {
    const regex = /^\d+(\.\d{1,2})?$/;
    return regex.test(input);
  };

  isValidDate = date => {
    const dateObject = new Date(date);
    return dateObject instanceof Date && !isNaN(dateObject);
  };

  getCountries = () => {
    return getFilteredCountries(this.state.countriesSearchTerm);
  };

  onCountryChange = async e => {
    this.setState({
      country: e.target.value,
      countriesSearchTerm: '',
      state: 'Select State',
      states: []
    });
    try {
      this.setState({
        loadingStates: true
      });
      const data = await api.getStatesFromCountry(e.target.value);
      this.setState({
        states: data.states
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({
        loadingStates: false
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        {this.state.showModal && this.state.rzpData ? (
          <Dialog
            open={this.state.showModal}
            onClose={() => {
              this.setState({ showModal: false });
            }}
          >
            <div
              style={{
                width: 400,
                height: 400,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start'
              }}
            >
              <div
                style={{
                  padding: 12
                }}
              >
                <Typography style={{ fontSize: 16, fontWeight: 700 }}>
                  Details
                </Typography>
              </div>

              <Divider
                style={{
                  width: '100%'
                }}
              />

              <div
                style={{
                  padding: 12,
                  flex: 1
                }}
              >
                <Typography style={{ fontSize: 16, fontWeight: 700 }}>
                  Bank Details
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                  Account No:{' '}
                  {this.state.rzpData.receivers.bankAccount.accountNumber}
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                  IFSC:
                  {this.state.rzpData.receivers.bankAccount.ifsc}
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                  Name: {this.state.rzpData.receivers.bankAccount.name}
                </Typography>

                <Typography
                  style={{ fontSize: 16, fontWeight: 700, marginTop: 24 }}
                >
                  UPI Details
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                  {this.state.rzpData.receivers.vpa.address}
                </Typography>
              </div>
              <Divider
                style={{
                  width: '100%'
                }}
              />
              <div
                style={{
                  padding: 12
                }}
              >
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `Bank Details: \nAccount No: ${this.state.rzpData.receivers.bankAccount.accountNumber} \nIFSC: ${this.state.rzpData.receivers.bankAccount.ifsc} \nName: ${this.state.rzpData.receivers.bankAccount.name} \n\nUPI Details: \n${this.state.rzpData.receivers.vpa.address}`
                    );
                  }}
                >
                  Copy
                </Button>
                <Button
                  onClick={() => {
                    this.setState({ showModal: false });
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </Dialog>
        ) : null}
        <Styled.RazorpaySmartCollectContainer>
          <Styled.Title>DoubleTick Enterprise Plan</Styled.Title>
          <FormControl>
            <Styled.LabelAndTextField>
              <Styled.Label>Login phone number*</Styled.Label>
              <FormControl
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row'
                }}
              >
                <Select
                  MenuProps={{ autoFocus: false }}
                  labelId="search-select-label"
                  id="search-select"
                  value={this.state.countryCode}
                  label="Options"
                  onChange={e =>
                    this.setState({
                      countryCode: e.target.value,
                      countriesSearchTerm: ''
                    })
                  }
                  defaultValue={this.state.countryCode}
                  disableUnderline
                  classes={{
                    select: classes.phoneSelect
                  }}
                  style={{
                    padding: 10
                  }}
                  onClose={e => this.setState({ countriesSearchTerm: '' })}
                  renderValue={() => this.state.countryCode}
                >
                  <ListSubheader className={classes.subheader}>
                    <TextField
                      autoFocus
                      placeholder="Type to search..."
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        )
                      }}
                      value={this.state.countriesSearchTerm}
                      onClick={e => e.stopPropagation()}
                      onChange={e =>
                        this.setState({ countriesSearchTerm: e.target.value })
                      }
                      onKeyDown={e => {
                        if (e.key !== 'Escape') {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  {this.getCountries().map((option, i) => (
                    <MenuItem key={i} value={option.symbol}>
                      {option.label} ({option.symbol})
                    </MenuItem>
                  ))}
                </Select>
                <Styled.InputField>
                  <TextField
                    id="PhoneNumber"
                    type="number"
                    autoComplete="off"
                    style={{
                      margin: 0
                    }}
                    placeholder="0000000000"
                    className={classes.textField}
                    onChange={this.onPhoneNumberChange}
                    value={this.state.phone}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                </Styled.InputField>
              </FormControl>
              {this.state.phoneError && (
                <Styled.Error>Please enter a valid phone number</Styled.Error>
              )}
            </Styled.LabelAndTextField>

            <Styled.LabelAndTextField>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'start'
                }}
              >
                <Styled.Label>Amount*</Styled.Label>
                <Typography
                  style={{ fontSize: 12, color: '#737373', marginTop: 4 }}
                >
                  (Inclusive of tax)
                </Typography>
              </div>
              <FormControl>
                <TextField
                  id="amount"
                  autoComplete="off"
                  type="number"
                  className={classes.textField}
                  onChange={this.onAmountChange}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.input }
                  }}
                  placeholder="0000"
                  value={this.state.amount}
                />
                {this.state.amountError && (
                  <Styled.Error>Please enter a valid amount </Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            {/* <Styled.LabelAndTextField>
            <Styled.Label>Start Date*</Styled.Label>
            <TextField
              className={classes.textField}
              type="date"
              onChange={this.onDateChange}
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                disableUnderline: true,
                classes: { input: classes.input }
              }}
              value={
                this.state.startDate
                  ? new Date(this.state.startDate).toISOString().slice(0, 10)
                  : ''
              }
            />
            {this.state.startDateError && (
              <Styled.Error>Please enter start date</Styled.Error>
            )}
          </Styled.LabelAndTextField> */}
            <Styled.LabelAndTextField>
              <Styled.Label>Duration (in months)*</Styled.Label>
              <FormControl>
                <Select
                  className={classes.selectDropDown}
                  classes={{
                    select: classes.selectMenu
                  }}
                  disabled={this.state.loadingDuration}
                  disableUnderline
                  value={this.state.duration}
                  onChange={this.onDurationChange}
                  name={'durationInMonths'}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.state.durationMonths.map((option, index) => {
                    return (
                      <MenuItem key={index} value={option}>
                        {option} months
                      </MenuItem>
                    );
                  })}
                </Select>
                {this.state.durationError && (
                  <Styled.Error>Please select end time duration</Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>Plans</Styled.Label>
              <FormControl>
                <Select
                  className={classes.selectDropDown}
                  classes={{
                    select: classes.selectMenu
                  }}
                  disableUnderline
                  value={this.state.plan}
                  onChange={this.onPlanChange}
                  name={'productPlan'}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {DOUBLETICK_ENTERPRISE_PLANS.map((option, index) => {
                    return (
                      <MenuItem key={index} value={option.value}>
                        {option.name} Plan
                      </MenuItem>
                    );
                  })}
                </Select>
                {this.state.planError && (
                  <Styled.Error>Please select plan</Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>No. of users*</Styled.Label>
              <FormControl>
                <TextField
                  id="users"
                  autoComplete="off"
                  type="number"
                  className={classes.textField}
                  onChange={this.onNumberOfUsersChange}
                  placeholder="0"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.input }
                  }}
                  value={this.state.numberOfUsers}
                />
                {this.state.numberOfUsersError && (
                  <Styled.Error>Please enter number of users</Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>Name*</Styled.Label>
              <FormControl>
                <TextField
                  id="name"
                  autoComplete="off"
                  type="text"
                  className={classes.textField}
                  onChange={this.onNameChange}
                  placeholder="John Doe"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.input }
                  }}
                  value={this.state.name}
                />
                {this.state.nameError && (
                  <Styled.Error>Please enter name</Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>Org Name*</Styled.Label>
              <FormControl>
                <TextField
                  id="companyName"
                  autoComplete="off"
                  type="text"
                  className={classes.textField}
                  onChange={this.onCompanyNameChange}
                  placeholder="ABC Jewels Pvt. Ltd."
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.input }
                  }}
                  value={this.state.companyName}
                />
                {this.state.companyNameError && (
                  <Styled.Error>Please enter org name</Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>Email</Styled.Label>
              <FormControl>
                <TextField
                  id="email"
                  autoComplete="off"
                  type="text"
                  className={classes.textField}
                  onChange={this.onEmailChange}
                  placeholder="email@email.com"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.input }
                  }}
                  value={this.state.email}
                />
                {this.state.emailError && (
                  <Styled.Error>Please enter a valid email </Styled.Error>
                )}
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>GSTN</Styled.Label>
              <FormControl>
                <TextField
                  id="gstn"
                  autoComplete="off"
                  type="text"
                  className={classes.textField}
                  onChange={this.onGstnChange}
                  placeholder="00AAAAA0000A0A0"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: { input: classes.input }
                  }}
                  value={this.state.gst}
                />
              </FormControl>
            </Styled.LabelAndTextField>

            <Styled.LabelAndTextField>
              <Styled.Label>Country</Styled.Label>
              <FormControl>
                <Select
                  MenuProps={{ autoFocus: false }}
                  labelId="search-select-label"
                  id="search-select"
                  value={this.state.country}
                  label="Options"
                  onChange={this.onCountryChange}
                  defaultValue={this.state.country}
                  placeholder="Select Country"
                  disableUnderline
                  classes={{
                    select: classes.phoneSelect
                  }}
                  style={{
                    padding: 10
                  }}
                  onClose={e => this.setState({ countriesSearchTerm: '' })}
                >
                  <ListSubheader className={classes.subheader}>
                    <TextField
                      autoFocus
                      placeholder="Type to search..."
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        )
                      }}
                      value={this.state.countriesSearchTerm}
                      onClick={e => e.stopPropagation()}
                      onChange={e =>
                        this.setState({ countriesSearchTerm: e.target.value })
                      }
                      onKeyDown={e => {
                        if (e.key !== 'Escape') {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value={'Select Country'}>Select country</MenuItem>
                  {this.getCountries().map((option, i) => (
                    <MenuItem key={i} value={option.countryCode}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.Label>State</Styled.Label>
              <FormControl>
                <Select
                  MenuProps={{ autoFocus: false }}
                  labelId="search-select-label"
                  id="search-select"
                  value={this.state.state}
                  label="Options"
                  onChange={this.onStateChange}
                  defaultValue={this.state.state}
                  disabled={
                    !this.state.country ||
                    this.state.loadingStates ||
                    this.state.states.length < 1
                  }
                  disableUnderline
                  classes={{
                    select: classes.phoneSelect
                  }}
                  style={{
                    padding: 10
                  }}
                  onClose={e => this.setState({ statesSearchTerm: '' })}
                  renderValue={() => this.state.state}
                >
                  <ListSubheader className={classes.subheader}>
                    <TextField
                      autoFocus
                      placeholder="Type to search..."
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        )
                      }}
                      value={this.state.statesSearchTerm}
                      onClick={e => e.stopPropagation()}
                      onChange={e =>
                        this.setState({ statesSearchTerm: e.target.value })
                      }
                      onKeyDown={e => {
                        if (e.key !== 'Escape') {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <MenuItem value={'Select State'}>Select state</MenuItem>
                  {this.getStates().map(option => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Styled.LabelAndTextField>
            <Styled.LabelAndTextField>
              <Styled.InputField>
                <Button
                  tabIndex="-1"
                  type="submit"
                  classes={{ root: classes.button }}
                  onClick={this.onCreateRazorpaySmartId}
                  disabled={this.state.loading}
                >
                  Create DoubleTick Enterprise Plan
                  {this.state.loading ? (
                    <Styled.LoaderContainer
                      style={{
                        marginLeft: 10
                      }}
                    >
                      <CircularProgress
                        size={20}
                        thickness={5}
                        color="primary"
                      />
                    </Styled.LoaderContainer>
                  ) : null}
                </Button>
                {this.state.errorRazorpaySmartCollect && (
                  <Styled.Error>Something went wrong </Styled.Error>
                )}
              </Styled.InputField>
            </Styled.LabelAndTextField>
          </FormControl>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            open={this.state.showSnackBar}
            onClose={this.onSnackbarClose}
            autoHideDuration={3000}
            message={this.renderSnackbarMessage()}
            action={[
              <IconButton key={0} onClick={this.onSnackbarClose}>
                <CloseIcon nativeColor="#fff" />
              </IconButton>
            ]}
          />
        </Styled.RazorpaySmartCollectContainer>
      </Fragment>
    );
  }
}

export default withStyles(styles)(RazorpaySmartCollect);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/RazorpaySmartCollect/index.js